module.exports = __webpack_public_path__ + "img/Classification.1277d354.png";